import { useState } from 'react';
import { UserPlus, Check, Heart } from 'lucide-react';
import { getTeamFlag } from '../../utils/teamFlags';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SUGGESTED_TEAMS = [
  { name: 'Al Ahly', league: 'Egyptian Premier League' },
  { name: 'Mamelodi Sundowns', league: 'South African PSL' },
  { name: 'TP Mazembe', league: 'Linafoot' },
  { name: 'Esperance', league: 'Tunisian Ligue 1' },
  { name: 'Wydad AC', league: 'Botola Pro' },
  { name: 'Orlando Pirates', league: 'South African PSL' },
  { name: 'Kaizer Chiefs', league: 'South African PSL' },
  { name: 'Zamalek', league: 'Egyptian Premier League' },
  { name: 'Raja Casablanca', league: 'Botola Pro' },
  { name: 'Simba SC', league: 'Tanzanian Premier League' },
];

export function SuggestedTeamsSection({ navigate }) {
  const [followed, setFollowed] = useState(new Set());
  const [loading, setLoading] = useState(null);

  const isLoggedIn = !!localStorage.getItem('token');

  const followTeam = async (teamName) => {
    if (!isLoggedIn) {
      navigate('/login');
      return;
    }
    setLoading(teamName);
    const token = localStorage.getItem('token');
    try {
      await fetch(`${API}/user/follow-team`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ team_name: teamName }),
      });
      setFollowed(prev => new Set([...prev, teamName]));
    } catch { /* silent */ }
    finally { setLoading(null); }
  };

  return (
    <section className="py-5 sm:py-6" data-testid="suggested-teams-section">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex items-center gap-3 mb-2">
          <Heart className="w-5 h-5 text-red-400 shrink-0" />
          <h2 className="text-lg sm:text-xl font-bold text-white tracking-tight">Follow Your Favorite Teams</h2>
        </div>
        <p className="text-gray-500 text-xs mb-5 ml-8">Personalize your feed by following teams you care about</p>

        {/* Team grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
          {SUGGESTED_TEAMS.map((team) => {
            const flag = getTeamFlag(team.name);
            const isFollowed = followed.has(team.name);
            const isLoading = loading === team.name;

            return (
              <button
                key={team.name}
                onClick={() => !isFollowed && followTeam(team.name)}
                disabled={isFollowed || isLoading}
                className={`relative p-4 rounded-xl border text-left transition-all duration-200 group ${
                  isFollowed
                    ? 'bg-emerald-500/10 border-emerald-500/25'
                    : 'bg-[#141414] border-white/[0.06] hover:border-emerald-500/30 hover:bg-[#1a1a1a]'
                }`}
                data-testid={`suggest-team-${team.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div className="flex items-center gap-2.5 mb-2">
                  {flag ? (
                    <span className="text-2xl">{flag}</span>
                  ) : (
                    <span className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-[10px] font-bold text-gray-300">
                      {team.name.slice(0, 3).toUpperCase()}
                    </span>
                  )}
                  <div className="min-w-0 flex-1">
                    <p className="text-white font-semibold text-sm truncate">{team.name}</p>
                    <p className="text-white/30 text-[10px] truncate">{team.league}</p>
                  </div>
                </div>
                <div className={`flex items-center justify-center gap-1.5 py-1.5 rounded-lg text-[10px] font-bold uppercase tracking-wide transition-colors ${
                  isFollowed
                    ? 'bg-emerald-500/15 text-emerald-400'
                    : 'bg-white/[0.06] text-white/50 group-hover:bg-emerald-600/20 group-hover:text-emerald-400'
                }`}>
                  {isFollowed ? (
                    <><Check className="w-3 h-3" /> Following</>
                  ) : isLoading ? (
                    <span className="w-3 h-3 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
                  ) : (
                    <><UserPlus className="w-3 h-3" /> Follow</>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
